import React from "react";
import * as Icon from "react-feather";
import "../../../../afs-walkthrough.css";
import WComponent from "../../../../../../../common/WComponent";

class AJEScratchPad extends WComponent {
	state = {
		description: "",
		debitSearch: "",
		creditSearch: "",
		debitCode: null,
		debitLabel: "",
		creditCode: null,
		creditLabel: "",
		amount: "",
		added: false,
		showDebitPicker: false,
		showCreditPicker: false,
		// Inline create-account form (per side)
		creatingFor: null,
		newAccountNumber: "",
		newAccountName: "",
		newCanonicalCode: null,
		newCanonicalLabel: "",
		newCanonicalSearch: "",
		newAccountSaving: false,
		newAccountError: null,
	};

	render() {
	let { chartOfAccounts, canonicalTaxonomyOptions, onApproveAJE, onClose, onCreateChartOfAccount } = this.props;
	let { description, debitSearch, creditSearch, debitCode, debitLabel, creditCode, creditLabel, amount, added, showDebitPicker, showCreditPicker, creatingFor, newAccountNumber, newAccountName, newCanonicalCode, newCanonicalLabel, newCanonicalSearch, newAccountSaving, newAccountError } = this.state;

	let options = (function () {
		return (chartOfAccounts || []).filter(function (acct) {
			return acct.canonical_code || acct.accountNumber;
		}).map(function (acct) {
			return {
				// Picker key — falls back to account_number for newly-created accounts that
				// haven't been mapped to canonical yet.
				canonical_code: acct.canonical_code || acct.accountNumber,
				label: acct.accountName || acct.display_name || acct.accountDescription || acct.description || acct.canonical_code,
				gifi_code: acct.gifi_code,
				unmapped: !acct.canonical_code,
			};
		});
	})();

	const filterOptions = (searchText) => {
		let q = (searchText || "").trim().toLowerCase();
		if (!q) return options.slice(0, 8);
		return options.filter(function (opt) {
			return opt.label.toLowerCase().includes(q) || (opt.canonical_code || "").toLowerCase().includes(q);
		}).slice(0, 8);
	};

	const openCreateForm = (side, prefillName) => {
		this.update({
			creatingFor: side,
			newAccountNumber: "",
			newAccountName: prefillName || "",
			newCanonicalCode: null,
			newCanonicalLabel: "",
			newCanonicalSearch: "",
			newAccountError: null,
			newAccountSaving: false,
		});
	};

	const closeCreateForm = () => {
		this.update({ creatingFor: null, newAccountError: null, newAccountSaving: false });
	};

	const filterCanonical = (query) => {
		const list = canonicalTaxonomyOptions || [];
		const q = (query || "").trim().toLowerCase();
		if (!q) return list.slice(0, 8);
		return list.filter(t =>
			(t.display_name || "").toLowerCase().includes(q) ||
			(t.canonical_code || "").toLowerCase().includes(q) ||
			String(t.gifi_code || "").includes(q)
		).slice(0, 8);
	};

	const submitCreateForm = async (side) => {
		if (!onCreateChartOfAccount) {
			this.update({ newAccountError: "Account creation isn't available in this context" });
			return;
		}
		if (!newAccountNumber.trim() || !newAccountName.trim()) {
			this.update({ newAccountError: "Account number and name are required" });
			return;
		}
		if (!newCanonicalCode) {
			this.update({ newAccountError: "Pick a canonical account or GIFI line — this anchors where the new account rolls up on the FS" });
			return;
		}
		this.update({ newAccountSaving: true, newAccountError: null });
		const result = await onCreateChartOfAccount({
			accountNumber: newAccountNumber.trim(),
			accountName: newAccountName.trim(),
			canonicalCode: newCanonicalCode,
		});
		if (result && result.account) {
			const acct = result.account;
			const code = acct.canonical_code || acct.accountNumber;
			const label = acct.accountName || acct.accountDescription || acct.account_description || code;
			const sideUpdate = side === "debit"
				? { debitCode: code, debitLabel: label, debitSearch: "", showDebitPicker: false }
				: { creditCode: code, creditLabel: label, creditSearch: "", showCreditPicker: false };
			this.update({ ...sideUpdate, creatingFor: null, newAccountSaving: false, newAccountNumber: "", newAccountName: "", newCanonicalCode: null, newCanonicalLabel: "", newCanonicalSearch: "" });
		} else {
			this.update({ newAccountSaving: false, newAccountError: (result && result.error) || "Failed to create account" });
		}
	};

	const renderCreateForm = (side) => (
		<div className="afs-aje__create-account">
			<div className="afs-aje__create-account-title">Add new account</div>
			<input
				className="afs-aje-pad__account-input"
				type="text"
				placeholder="Account number (e.g. 1245)"
				value={newAccountNumber}
				onChange={(e) => this.update({ newAccountNumber: e.target.value })}
				autoFocus
			/>
			<input
				className="afs-aje-pad__account-input"
				type="text"
				placeholder="Account name"
				value={newAccountName}
				onChange={(e) => this.update({ newAccountName: e.target.value })}
			/>
			<div className="afs-aje__create-account-canonical">
				<label className="afs-aje__create-account-label">Map to canonical / GIFI line</label>
				{newCanonicalCode ? (
					<div className="afs-aje-pad__account-selected">
						<span>{newCanonicalLabel}</span>
						<button className="afs-aje-pad__account-clear" onClick={() => this.update({ newCanonicalCode: null, newCanonicalLabel: "", newCanonicalSearch: "" })} title="Clear"><Icon.X size={12} /></button>
					</div>
				) : (
					<>
						<input
							className="afs-aje-pad__account-input"
							type="text"
							placeholder="Search canonical name or GIFI code…"
							value={newCanonicalSearch}
							onChange={(e) => this.update({ newCanonicalSearch: e.target.value })}
						/>
						<div className="afs-aje__canonical-dropdown">
							{(canonicalTaxonomyOptions || []).length === 0 && (
								<div className="afs-aje__picker-empty">Canonical taxonomy not loaded</div>
							)}
							{filterCanonical(newCanonicalSearch).map((t) => (
								<button
									key={t.canonical_code}
									className="afs-aje-pad__account-option"
									onClick={() => this.update({ newCanonicalCode: t.canonical_code, newCanonicalLabel: t.display_name + (t.gifi_code ? ` (GIFI ${t.gifi_code})` : "") })}
								>
									<span>{t.display_name}</span>
									{t.gifi_code ? <span className="afs-aje-pad__account-gifi">GIFI {t.gifi_code}</span> : null}
								</button>
							))}
						</div>
					</>
				)}
			</div>
			{newAccountError && <div className="afs-aje__create-account-error">{newAccountError}</div>}
			<div className="afs-aje__create-account-actions">
				<button className="afs-aje__btn" onClick={closeCreateForm} disabled={newAccountSaving}>Cancel</button>
				<button className="afs-aje__btn afs-aje__btn--primary" onClick={() => submitCreateForm(side)} disabled={newAccountSaving}>
					{newAccountSaving ? "Adding…" : "Add account"}
				</button>
			</div>
		</div>
	);

	const handleAdd = () => {
		if (!debitCode || !creditCode || !amount || !description) return;
		let numAmount = parseFloat(amount) || 0;
		if (numAmount <= 0) return;

		if (onApproveAJE) {
			onApproveAJE({
				description: description,
				debitAccount: debitLabel,
				debitCanonicalCode: debitCode,
				creditAccount: creditLabel,
				creditCanonicalCode: creditCode,
				amount: numAmount,
			});
		}
		this.update({ added: true });
	};

	const handleReset = () => {
		this.update({ description: "" });
		this.update({ debitSearch: "" }); this.update({ debitCode: null }); this.update({ debitLabel: "" });
		this.update({ creditSearch: "" }); this.update({ creditCode: null }); this.update({ creditLabel: "" });
		this.update({ amount: "" });
		this.update({ added: false });
		this.update({ showDebitPicker: false });
		this.update({ showCreditPicker: false });
	};

	let isValid = debitCode && creditCode && parseFloat(amount) > 0 && description.trim().length > 0;

	if (added) {
		let numAmount = parseFloat(amount) || 0;
		return (
			<div className="afs-aje-pad">
				<div className="afs-aje-pad__header">
					<div className="afs-aje-pad__header-title"><Icon.Edit3 size={16} /><span>Adjusting Entry</span></div>
					<button className="afs-aje-pad__close" onClick={onClose}><Icon.X size={16} /></button>
				</div>
				<div className="afs-aje-pad__confirmed">
					<Icon.CheckCircle size={18} color="#2e7d32" />
					<div className="afs-aje-pad__confirmed-detail">
						<span className="afs-aje-pad__confirmed-title">Entry added</span>
						<span className="afs-aje-pad__confirmed-line">DR {debitLabel} / CR {creditLabel}</span>
						<span className="afs-aje-pad__confirmed-amount">${numAmount.toLocaleString("en-CA")}</span>
					</div>
					<button className="afs-aje-pad__new-btn" onClick={handleReset}><Icon.Plus size={14} /> New Entry</button>
				</div>
			</div>
		);
	}

	return (
		<div className="afs-aje-pad">
			<div className="afs-aje-pad__header">
				<div className="afs-aje-pad__header-title"><Icon.Edit3 size={16} /><span>Adjusting Entry</span></div>
				<button className="afs-aje-pad__close" onClick={onClose}><Icon.X size={16} /></button>
			</div>

			<div className="afs-aje-pad__form">
				<div className="afs-aje-pad__field">
					<label className="afs-aje-pad__label">Description</label>
					<input className="afs-aje-pad__input" type="text" placeholder="e.g., Record year-end bonus accrual" value={description} onChange={(e) => { this.update({ description: e.target.value }); }} />
				</div>

				<div className="afs-aje-pad__entry-row">
					<span className="afs-aje-pad__side afs-aje-pad__side--dr">DR</span>
					<div className="afs-aje-pad__account-picker">
						{debitCode ? (
							<div className="afs-aje-pad__account-selected">
								<span>{debitLabel}</span>
								<button className="afs-aje-pad__account-clear" onClick={() => { this.update({ debitCode: null }); this.update({ debitLabel: "" }); this.update({ debitSearch: "" }); this.update({ showDebitPicker: true }); }}><Icon.X size={12} /></button>
							</div>
						) : creatingFor === "debit" ? (
							renderCreateForm("debit")
						) : (
							<>
								<input className="afs-aje-pad__account-input" type="text" placeholder="Search debit account..." value={debitSearch} onChange={(e) => { this.update({ debitSearch: e.target.value }); this.update({ showDebitPicker: true }); }} onFocus={() => { this.update({ showDebitPicker: true }); this.update({ showCreditPicker: false }); }} />
								{showDebitPicker && (
									<div className="afs-aje-pad__account-dropdown">
										{filterOptions(debitSearch).map((opt) => {
											return <button key={opt.canonical_code} className="afs-aje-pad__account-option" onClick={() => { this.update({ debitCode: opt.canonical_code }); this.update({ debitLabel: opt.label }); this.update({ showDebitPicker: false }); }}>{opt.label}{opt.gifi_code ? <span className="afs-aje-pad__account-gifi"> GIFI {opt.gifi_code}</span> : null}</button>;
										})}
										{onCreateChartOfAccount && (
											<button className="afs-aje-pad__account-option afs-aje__add-account" onClick={() => openCreateForm("debit", debitSearch)}>
												<Icon.Plus size={12} className="afs-aje__inline-icon" />
												<span>Add new account{debitSearch ? ` "${debitSearch}"` : ""}</span>
											</button>
										)}
									</div>
								)}
							</>
						)}
					</div>
				</div>

				<div className="afs-aje-pad__entry-row">
					<span className="afs-aje-pad__side afs-aje-pad__side--cr">CR</span>
					<div className="afs-aje-pad__account-picker">
						{creditCode ? (
							<div className="afs-aje-pad__account-selected">
								<span>{creditLabel}</span>
								<button className="afs-aje-pad__account-clear" onClick={() => { this.update({ creditCode: null }); this.update({ creditLabel: "" }); this.update({ creditSearch: "" }); this.update({ showCreditPicker: true }); }}><Icon.X size={12} /></button>
							</div>
						) : creatingFor === "credit" ? (
							renderCreateForm("credit")
						) : (
							<>
								<input className="afs-aje-pad__account-input" type="text" placeholder="Search credit account..." value={creditSearch} onChange={(e) => { this.update({ creditSearch: e.target.value }); this.update({ showCreditPicker: true }); }} onFocus={() => { this.update({ showCreditPicker: true }); this.update({ showDebitPicker: false }); }} />
								{showCreditPicker && (
									<div className="afs-aje-pad__account-dropdown">
										{filterOptions(creditSearch).map((opt) => {
											return <button key={opt.canonical_code} className="afs-aje-pad__account-option" onClick={() => { this.update({ creditCode: opt.canonical_code }); this.update({ creditLabel: opt.label }); this.update({ showCreditPicker: false }); }}>{opt.label}{opt.gifi_code ? <span className="afs-aje-pad__account-gifi"> GIFI {opt.gifi_code}</span> : null}</button>;
										})}
										{onCreateChartOfAccount && (
											<button className="afs-aje-pad__account-option afs-aje__add-account" onClick={() => openCreateForm("credit", creditSearch)}>
												<Icon.Plus size={12} className="afs-aje__inline-icon" />
												<span>Add new account{creditSearch ? ` "${creditSearch}"` : ""}</span>
											</button>
										)}
									</div>
								)}
							</>
						)}
					</div>
				</div>

				<div className="afs-aje-pad__field">
					<label className="afs-aje-pad__label">Amount</label>
					<div className="afs-aje-pad__amount-wrap">
						<span className="afs-aje-pad__amount-sign">$</span>
						<input className="afs-aje-pad__amount-input" type="number" min="0" step="0.01" placeholder="0.00" value={amount} onChange={(e) => { this.update({ amount: e.target.value }); }} />
					</div>
				</div>

				<button className="afs-aje-pad__add-btn" disabled={!isValid} onClick={handleAdd}>
					<Icon.Check size={14} /> Add Entry
				</button>
			</div>
		</div>
	);
	}
}

export default AJEScratchPad;
